import api from "./api";

const StockSalesReportService = {
  getReport: async (params) => {
    const response = await api.get("/stockSalesReport/getReport", {
      params: {
        companyId: params.companyId || undefined,
        employeeId: params.employeeId || undefined,
        roleId: params.roleId || undefined,
        projectId: params.projectId || undefined,
        storeId: params.storeId || undefined,
        customerId: params.customerId || undefined,
        customerStoreId: params.customerStoreId || undefined,
        startDate: params.startDate || undefined,
        endDate: params.endDate || undefined,
        page: params.page || 1,
        limit: params.limit || 10,
      },
    });

    return response.data;
  },
};

export default StockSalesReportService;
